import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormHelperText,
    List,
    ListItem,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../component/AuthContext/AuthContext";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { resetProfile, resetToken, setRedirectTo } from "../../redux/action";
import { getRedirectUrl } from "../../redux/selector";
import { send } from "../../SendRequest";
import { isEmpty, isNotEmpty, isObjectEmpty } from "../../Utils";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    eye: {
        transform: "translate(10px)",
    },
    authChangePassword: {
        flex: "1 1",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        [`& nav`]: {
            width: "100%",
            [`& li`]: {
                width: "100%",
                justifyContent: "center",
            },
        },
    },
    main: {
        flex: "1 1",
    },
});
function ChangePassword() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [currPw, setCurrPw] = useState("");
    const [newPw, setNewPw] = useState("");
    const [reNewPw, setReNewPw] = useState("");
    const [post, setPost] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isWrongLoginInfo, setIsWrongLoginInfo] = useState(false);
    const [isDiffNewPw, setIsDiffNewPw] = useState(false);
    const [unchangedPw, setUnchangedPw] = useState(false);
    const [url, setUrl] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [changeFail, setChangeFail] = useState("");
    const [passwordPolicyEight, setPasswordPolicyEight] = useState(false);
    const [passwordPolicyTen, setPasswordPolicyTen] = useState(false);
    // const [newPasswordPolicyEight, setNewPasswordPolicyEight] = useState(false);
    // const [newPasswordPolicyTen, setNewPasswordPolicyTen] = useState(false);
    const [emptyCurPw, setEmptyCurPw] = useState(false);
    const [emptyNewPw, setEmptyNewPw] = useState(false);
    const { isChangingPassword, setIsChangingPassword } = useAuth();

    const redirectUrl = useSelector(getRedirectUrl());

    const handleConfirm = () => {
        setIsWrongLoginInfo(false);
    };
    const handleSavedClose = () => {
        setIsOpen(false);
        removeCookie("token", {
            path: `${Config.CONTENT_PATH}`,
        });
        dispatch(resetToken());
        dispatch(resetProfile());
        navigate(url);
    };

    // useEffect(() => {
    //     return () => {
    //         removeCookie("token", {
    //             path: `${Config.CONTENT_PATH}`,
    //         });
    //         dispatch(resetToken());
    //         dispatch(resetProfile());
    //     };
    // }, []);

    // window.onunload = function (e) {
    //     removeCookie("token", {
    //         path: `${Config.CONTENT_PATH}`,
    //     });
    //     dispatch(resetToken());
    //     dispatch(resetProfile());
    // };

    function SavedDialog(isOpen) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={isOpen}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.passwordUpdated")}
                    </DialogTitle>
                    <DialogContent>
                        {t("common.portal.passwordUpdatedSuccessfully")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    const checkPolicy = (value) => {
        const regexEight =
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()\-=+[\]{}\\|,.<>?/]).{8,}$/;
        if (value?.length < 10) {
            setPasswordPolicyTen(false);
            if (regexEight.test(value)) {
                setPasswordPolicyEight(false);
            } else {
                setPasswordPolicyEight(true);
            }
        } else {
            setPasswordPolicyEight(false);
            const hasLowerCase = /[a-z]/.test(value);
            const hasUpperCase = /[A-Z]/.test(value);
            const hasDigit = /\d/.test(value);
            const hasSpecialChar = /[~!@#$%^&*()\-=+[\]{}\\|,.<>?/]/.test(
                value
            );

            const validGroups = [
                hasLowerCase,
                hasUpperCase,
                hasDigit,
                hasSpecialChar,
            ].filter(Boolean).length;

            if (validGroups >= 3) {
                setPasswordPolicyTen(false);
            } else {
                setPasswordPolicyTen(true);
            }
        }
    };

    // const checkNewPolicy = (value) => {
    //     const regexEight =
    //         /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()\-=+[\]{}\\|,.<>?/]).{8,}$/;
    //     if (value?.length < 10) {
    //         setNewPasswordPolicyTen(false);
    //         if (regexEight.test(value)) {
    //             setNewPasswordPolicyEight(false);
    //         } else {
    //             setNewPasswordPolicyEight(true);
    //         }
    //     } else {
    //         setNewPasswordPolicyEight(false);
    //         const hasLowerCase = /[a-z]/.test(value);
    //         const hasUpperCase = /[A-Z]/.test(value);
    //         const hasDigit = /\d/.test(value);
    //         const hasSpecialChar = /[~!@#$%^&*()\-=+[\]{}\\|,.<>?/]/.test(
    //             value
    //         );

    //         const validGroups = [
    //             hasLowerCase,
    //             hasUpperCase,
    //             hasDigit,
    //             hasSpecialChar,
    //         ].filter(Boolean).length;

    //         if (validGroups >= 3) {
    //             setNewPasswordPolicyTen(false);
    //         } else {
    //             setNewPasswordPolicyTen(true);
    //         }
    //     }
    // };

    const onSubmit = () => {
        console.log("submitted:" + currPw + " " + newPw + " " + reNewPw);
        if (newPw === reNewPw) {
            setIsDiffNewPw(false);
            if (currPw !== newPw) {
                setUnchangedPw(false);
                if (
                    passwordPolicyEight === false &&
                    passwordPolicyTen === false
                ) {
                    const data = {};
                    data[`password`] = newPw;
                    data[`oldPassword`] = currPw;
                    console.log("submitted:" + JSON.stringify(data));
                    const option = {
                        url: `${Config.CONTENT_PATH}/users/changepw`,
                        method: "POST",
                        body: JSON.stringify(data),
                    };
                    dispatch(send("CHANGE_PASSWORD", option))
                        .then((response) => response.json())
                        .then((result) => {
                            console.log("result:" + JSON.stringify(result));
                            if (isObjectEmpty(result)) {
                                setIsWrongLoginInfo(true);
                            } else if (isNotEmpty(result?.redirectUrl)) {
                                setIsOpen(true);
                                setUrl(result?.redirectUrl);
                                dispatch(setRedirectTo(result?.redirectUrl));
                                setIsChangingPassword(false);
                            } else {
                                const errMsgList = {
                                    INVALID_PASSWORD: "invalidPassword",
                                    REPEAT_PASSWORD: "repeatPassword",
                                    LAST_8_PASSWORDS_NOT_ALLOWED:
                                        "last8PasswordsNotAllowed",
                                };
                                if (isNotEmpty(errMsgList?.[result?.msg])) {
                                    setChangeFail(errMsgList[result.msg]);
                                }
                            }
                        })
                        .catch((error) => {
                            console.log("fetch error: ", error);
                        });
                }
            } else {
                setUnchangedPw(true);
            }
        } else {
            setIsDiffNewPw(true);
        }
    };

    const onClickVisible = () => {
        if (passwordVisible) {
            setPasswordVisible(false);
        } else {
            setPasswordVisible(true);
        }
    };
    // 进入页面时激活拦截
    useEffect(() => {
        if (redirectUrl === "/changePassword") {
            setIsChangingPassword(true);
        } else {
            setIsChangingPassword(false);
        }
        // return () => setIsChangingPassword(false); // 离开时关闭拦截
    }, [redirectUrl]);

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.portal.changePassword")}
                className="header"
            ></Header>
            <Box className="container">
                {!isChangingPassword && (
                    <PortalNavbar aside className="drawer" />
                )}
                <main
                    Box
                    className={
                        isChangingPassword
                            ? classes.authChangePassword
                            : classes.main
                    }
                >
                    {isChangingPassword && (
                        <Typography style={{ marginLeft: "1rem" }}>
                            {t("errorMsg.login.passwordExpired")}
                        </Typography>
                    )}
                    <List
                        sx={{
                            width: "100%",
                            maxWidth: 360,
                            bgcolor: "background.paper",
                            p: 2,
                        }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItem>
                            <Typography
                                style={{
                                    width:
                                        i18n.language === "en"
                                            ? "12rem"
                                            : "6rem",
                                    textAlign: "end",
                                }}
                            >
                                {t("common.portal.oldPw")}: &nbsp;
                            </Typography>
                            <CustomTextField
                                style={{ width: "40%" }}
                                defaultValue={currPw}
                                onChange={(e) => {
                                    setCurrPw(e.target.value);
                                    if (isNotEmpty(e.target.value)) {
                                        setEmptyCurPw(false);
                                    }
                                }}
                                type={passwordVisible ? null : "password"}
                                unit={
                                    passwordVisible === true ? (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                        >
                                            <VisibilityOffIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                        >
                                            <VisibilityIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    )
                                }
                            ></CustomTextField>
                        </ListItem>
                        {isWrongLoginInfo && (
                            <FormHelperText
                                style={{
                                    paddingLeft: isChangingPassword
                                        ? i18n.language === "en"
                                            ? "26rem"
                                            : "24rem"
                                        : i18n.language === "en"
                                        ? "12rem"
                                        : "6rem",
                                }}
                            >
                                <ErrorMsg
                                    message={t("errorMsg.login.invalidCurrPw")}
                                />
                            </FormHelperText>
                        )}
                        {emptyCurPw && (
                            <FormHelperText
                                style={{
                                    paddingLeft: isChangingPassword
                                        ? i18n.language === "en"
                                            ? "26rem"
                                            : "24rem"
                                        : i18n.language === "en"
                                        ? "12rem"
                                        : "6rem",
                                }}
                            >
                                <ErrorMsg message={t("errorMsg.required")} />
                            </FormHelperText>
                        )}
                        <ListItem>
                            <Typography
                                style={{
                                    width:
                                        i18n.language === "en"
                                            ? "12rem"
                                            : "6rem",
                                    textAlign: "end",
                                }}
                            >
                                {t("common.portal.newPw")}: &nbsp;
                            </Typography>
                            <CustomTextField
                                style={{ width: "40%" }}
                                defaultValue={newPw}
                                onChange={(e) => {
                                    checkPolicy(e.target.value);
                                    setNewPw(e.target.value);
                                    if (isNotEmpty(e.target.value)) {
                                        setEmptyNewPw(false);
                                        if (reNewPw === e.target.value) {
                                            setIsDiffNewPw(false);
                                        }
                                    }
                                }}
                                type={passwordVisible ? null : "password"}
                                unit={
                                    passwordVisible === true ? (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                        >
                                            <VisibilityOffIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                        >
                                            <VisibilityIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    )
                                }
                            ></CustomTextField>
                        </ListItem>
                        {isNotEmpty(newPw) && (
                            <>
                                <Box>
                                    <FormHelperText
                                        style={{
                                            paddingLeft: isChangingPassword
                                                ? i18n.language === "en"
                                                    ? "26rem"
                                                    : "24rem"
                                                : i18n.language === "en"
                                                ? "12rem"
                                                : "6rem",
                                        }}
                                    >
                                        {passwordPolicyEight && (
                                            <ErrorMsg
                                                message={t(
                                                    "errorMsg.login.passwordPolicyEight"
                                                )}
                                            />
                                        )}
                                        {passwordPolicyTen && (
                                            <ErrorMsg
                                                message={t(
                                                    "errorMsg.login.passwordPolicyTen"
                                                )}
                                            />
                                        )}
                                    </FormHelperText>
                                </Box>
                            </>
                        )}
                        {emptyNewPw && (
                            <FormHelperText
                                style={{
                                    paddingLeft: isChangingPassword
                                        ? i18n.language === "en"
                                            ? "26rem"
                                            : "24rem"
                                        : i18n.language === "en"
                                        ? "12rem"
                                        : "6rem",
                                }}
                            >
                                <ErrorMsg message={t("errorMsg.required")} />
                            </FormHelperText>
                        )}

                        <ListItem>
                            <Typography
                                style={{
                                    width:
                                        i18n.language === "en"
                                            ? "12rem"
                                            : "6rem",
                                    textAlign: "end",
                                }}
                            >
                                {t("common.portal.re-enterNewPw")}: &nbsp;
                            </Typography>
                            <CustomTextField
                                style={{ width: "40%" }}
                                defaultValue={reNewPw}
                                onChange={(e) => {
                                    // checkNewPolicy(e.target.value);
                                    setReNewPw(e.target.value);
                                    if (isNotEmpty(e.target.value)) {
                                        if (newPw === e.target.value) {
                                            setIsDiffNewPw(false);
                                        }
                                    }
                                }}
                                type={passwordVisible ? null : "password"}
                                unit={
                                    passwordVisible === true ? (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                        >
                                            <VisibilityOffIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    ) : (
                                        <Button
                                            onClick={onClickVisible}
                                            disableRipple={true}
                                            className={classes.eye}
                                        >
                                            <VisibilityIcon
                                                style={{ color: "gray" }}
                                            />
                                        </Button>
                                    )
                                }
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        if (isEmpty(currPw)) {
                                            setEmptyCurPw(true);
                                        }
                                        if (isEmpty(newPw)) {
                                            setEmptyNewPw(true);
                                        }
                                        if (
                                            isNotEmpty(currPw) &&
                                            isNotEmpty(newPw)
                                        ) {
                                            onSubmit();
                                        }
                                    }
                                }}
                            ></CustomTextField>
                        </ListItem>

                        {isDiffNewPw && (
                            <FormHelperText
                                style={{
                                    paddingLeft: isChangingPassword
                                        ? i18n.language === "en"
                                            ? "26rem"
                                            : "24rem"
                                        : i18n.language === "en"
                                        ? "12rem"
                                        : "6rem",
                                }}
                            >
                                <ErrorMsg
                                    message={t("errorMsg.login.diffNewPw")}
                                />
                            </FormHelperText>
                        )}
                        {unchangedPw && (
                            <FormHelperText
                                style={{
                                    paddingLeft: isChangingPassword
                                        ? i18n.language === "en"
                                            ? "26rem"
                                            : "24rem"
                                        : i18n.language === "en"
                                        ? "12rem"
                                        : "6rem",
                                }}
                            >
                                <ErrorMsg
                                    message={t("errorMsg.login.unchangedPw")}
                                />
                            </FormHelperText>
                        )}

                        {isNotEmpty(changeFail) && (
                            <FormHelperText
                                style={{
                                    paddingLeft: isChangingPassword
                                        ? i18n.language === "en"
                                            ? "26rem"
                                            : "24rem"
                                        : i18n.language === "en"
                                        ? "12rem"
                                        : "6rem",
                                }}
                            >
                                <ErrorMsg
                                    message={t(`errorMsg.login.${changeFail}`)}
                                />
                            </FormHelperText>
                        )}
                    </List>

                    <Divider
                        variant="middle"
                        style={
                            isChangingPassword
                                ? {
                                      width: "100%",
                                      height: "1px",
                                      marginLeft: "1rem",
                                  }
                                : { marginLeft: "1rem" }
                        }
                    />
                    <br />
                    <Button
                        style={{
                            marginLeft: isChangingPassword ? "1rem" : "14rem",
                        }}
                        className="buttons"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            if (isEmpty(currPw)) {
                                setEmptyCurPw(true);
                            }
                            if (isEmpty(newPw)) {
                                setEmptyNewPw(true);
                            }
                            if (isNotEmpty(currPw) && isNotEmpty(newPw)) {
                                onSubmit();
                            }
                        }}
                    >
                        {t("common.portal.updatePw")}
                    </Button>

                    <br />
                    {/* </Box> */}
                </main>
            </Box>
            {isOpen ? <SavedDialog isOpen={isOpen} /> : null}
            {/* <AlertDialog
                formOpen={isWrongLoginInfo}
                content={t("errorMsg.login.invalidCurrPw")}
                confirmButton={{
                    action: handleConfirm,
                    label: t("common.reload.popup.confirm"),
                }}
            /> */}
        </Container>
    );
}
export default ChangePassword;
